import React from "react";
import "../Styles/KgreatProjectPic.css";
import Gbagada from "../Components/Assets/Gbagada/GB1.jpg";
import Gbagada1 from "../Components/Assets/Gbagada/GB1.jpg";
import Gbagada2 from "../Components/Assets/Gbagada/GB2.jpg";
import Gbagada3 from "../Components/Assets/Gbagada/GB3.jpg";
import Gbagada4 from "../Components/Assets/Gbagada/GB4.jpg";
import Gbagada5 from "../Components/Assets/Gbagada/GB5.jpg";
import Gbagada6 from "../Components/Assets/Gbagada/GB6.jpg";
import Gbagada7 from "../Components/Assets/Gbagada/GB7.jpg";
import Gbagada8 from "../Components/Assets/Gbagada/GB8.jpg";
import Gbagada9 from "../Components/Assets/Gbagada/GB9.jpg";
import Gbagada10 from "../Components/Assets/Gbagada/GB10.jpg";
import Gbagada11 from "../Components/Assets/Gbagada/GB11.jpg";
import Gbagada12 from "../Components/Assets/Gbagada/GB12.jpg";
import Gbagada13 from "../Components/Assets/Gbagada/GB13.jpg";
import Gbagada14 from "../Components/Assets/Gbagada/GB14.jpg";
import Gbagada15 from "../Components/Assets/Gbagada/GB15.jpg";
import Gbagada16 from "../Components/Assets/Gbagada/GB16.jpg";
import Gbagada17 from "../Components/Assets/Gbagada/GB17.jpg";
import Gbagada18 from "../Components/Assets/Gbagada/GB18.jpg";
import Gbagada19 from "../Components/Assets/Gbagada/GB19.jpg";
import Gbagada20 from "../Components/Assets/Gbagada/GB20.jpg";
import Gbagada21 from "../Components/Assets/Gbagada/GB21.jpg";
import Gbagada22 from "../Components/Assets/Gbagada/GB22.jpg";
import Gbagada23 from "../Components/Assets/Gbagada/GB23.jpg";
import Gbagada24 from "../Components/Assets/Gbagada/GB24.jpg";
import Gbagada25 from "../Components/Assets/Gbagada/GB25.jpg";

const ProjPicGbagada = () => {
    return (
        <>
            <section className="sectionProjectPic">
                <div className="divProjPicLanding">
                    <div className="divProjectsImage">
                        <img
                            alt="ProjectPicture"
                            src={Gbagada}
                            className="projectsLandingImage"
                        />
                    </div>
                    <div className="divImageText">
                        <h1 className="headingImage">GBAGADA</h1>
                        <h1 className="headingImage1">GBAGADA</h1>
                        <p className="textOfImage">CONTRACTING</p>
                    </div>
                </div>

                {/* <div className="divProjPictTextOf">
                    <p className="aboutProject">
                        <span>PROJECT:</span> : PROPOSED RESIDENTIAL DEVELOPMENT FOR
                        LEVITIKAL GROUP AT OKO-AWO STREET, VICTORIA ISLAND, LAGOS.
                    </p>
                    <p className="aboutProject">
                        <span>BUILDING TYPE:</span>
                        MIXED TYPED RESIDENTIAL AND OFFICE BUILDING ON 23 FLOORS.
                    </p>
                    <p className="aboutProject">
                        <span>STATUS: </span>
                        ONGOING
                    </p>
                    <p className="aboutProject">
                        We were engaged to provide MEP consultancy & Installation services
                        for a mixed typed residential and office building on 23 floors. The
                        architectural design was carefully studied and state of the art and
                        modern applications in the MEP industry was utilized for the design
                        of the building. <br />
                        The plumbing services recommended for the building utlizes the top
                        range obatainable in the industry, Electrical system put into
                        consideration energy saving options for lighting and power
                        generation, and the Air conditioning was carefully thought out and
                        design to meet industry energy efficiency standards.
                    </p>
                </div> */}

                <div className="divProjPicMain">
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada1} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada2} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada11} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada12} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada13} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada14} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada15} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada16} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada17} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada18} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada19} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada20} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada21} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada22} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada23} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada24} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada25} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada3} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada4} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada5} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada6} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada7} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada8} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada9} className="projPicImageOf" />
                    </div>
                    <div className="divProjectImagesOf">
                        <img alt="HeroImg" src={Gbagada10} className="projPicImageOf" />
                    </div>

                </div>
            </section>
        </>
    );
};

export default ProjPicGbagada;
